<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="SK Organisasi Project">
            <br>
            <common-training-header :withUser="true"/>
        </a-page-header>

        <div class="text-right" style="margin-bottom: 24px">
            <a-button type="primary" icon="plus" @click="showModal('')" :disabled="!proposalRevision"> Tambah</a-button>
        </div>

        <a-card type="inner" size="small">
            <a-skeleton :loading="loading" active>
                <a-table
                    class="pcp-table"
                    :columns="columns"
                    :dataSource="data"
                    rowKey="id"
                    :pagination="false"
                    bordered>

                    <div slot="decree_number" slot-scope="record" style="text-align: left">
                        {{ record.decree_number }}
                    </div>

                    <div slot="title" slot-scope="record" style="text-align: left">
                        {{ record.title }}
                    </div>

                    <div slot="decree_date" slot-scope="record" style="text-align: left">
                        {{ moment(record.decree_date).format('DD MMMM YYYY') }}
                    </div>

                    <div slot="description" slot-scope="record" style="text-align: left">
                        {{ record.description }}
                    </div>

                    <div slot="file" slot-scope="record">
                        <a-button type="link" size="small"
                            @click="download(record.attachment)">
                            <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                        </a-button>
                    </div>

                    <div slot="action" slot-scope="record">
                        <a-tooltip title="Edit SK Organisasi">
                            <a-button
                                style="margin-left: 4px;"
                                size="small"
                                type="primary"
                                icon="edit"
                                @click="showModal(record.id)"
                            />
                        </a-tooltip>
                    </div>
                </a-table>
            </a-skeleton>

            <a-modal
                :visible="visible"
                :destroyOnClose="true"
                :footer="null"
                :closable="false"
            >
                <sk-organization-form
                    :hash="id"
                    @handleClose="closeModal"
                />
            </a-modal>
        </a-card>
    </div>
</template>

<script>
const columns = [
    {
		key: 'decree_number',
		title: 'Nomor SK',
        align: 'center',
		scopedSlots: {customRender: 'decree_number'},
	}, {
		key: 'title',
		title: 'Judul',
        align: 'center',
		scopedSlots: {customRender: 'title'},
	}, {
		key: 'decree_date',
		title: 'Tanggal',
        align: 'center',
		scopedSlots: {customRender: 'decree_date'}
	}, {
		key: 'description',
		title: 'Keterangan',
        align: 'center',
		scopedSlots: {customRender: 'description'}
	}, {
		key: 'file',
		title: 'File',
        align: 'center',
		scopedSlots: {customRender: 'file'}
	}, {
		key: 'action',
		title: 'Action',
        align: 'center',
		scopedSlots: {customRender: 'action'}
	}
]
export default {
    data() {
        return {
            columns,
            loading: false,
            visible: false,
            data: [],
            id: '',
            proposalRevision: false
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true
            this.$http
                .get(this.routeUri('api.project-management.sk-organization.index') + '?outline=project_evaluation')
                .then(response => {
                    this.data = response.data.decrees
                    this.proposalRevision = response.data.proposalRevision
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        showModal(id) {
            this.id = id
            this.visible = true
        },
        closeModal(isRefresh) {
            this.visible = false

            if (isRefresh == true) {
                this.getItems()
            }
        },
        download(url) {
            window.open(url, '_blank')
        },
    }
}
</script>
